import React from 'react';
import { Link } from 'react-router-dom';
import { FaAngleRight } from "react-icons/fa6";


interface Props {
  breadcrumbs: {
    label: string;
    path: string;
  }[];
}

export const Breadcrumb: React.FC<Props> = ({ breadcrumbs }) => {
  return (
    <div className='flex items-center text-sm'>
      {breadcrumbs.slice(0, -1).map((item) => (
        <div key={item.path} className='flex items-center text-cyan hover:underline cursor-pointer'>
          <Link to={item.path}>{item.label}</Link>
          <FaAngleRight className='mx-2 text-cyan size-3' />
        </div>
      ))}
      <span className='text-grey-600 truncate max-w-96'>{breadcrumbs[breadcrumbs.length - 1].label}</span>
    </div>
  );
};

